import { useAuthStore } from '@/app/store/authStore';

/**
 * Hook to access current user's role information and check role-based conditions
 *
 * @returns Object with role information and helper methods
 */
export const useRole = () => {
  const user = useAuthStore(state => state.user);

  const roleName = user?.role?.name;
  const roleId = user?.role?.id;

  return {
    // Raw role data
    roleName,
    roleId,
    role: user?.role,

    // Role type checks
    isSuperuser: roleName === 'superuser',
    isOrgAdmin: roleName === 'org_admin',
    isStandardUser: roleName === 'standard_user',
    isClient: roleName === 'client',
    isFieldAgent: roleName === 'field_agent',
    isClientManager: roleName === 'client_manager',

    // Grouped checks
    isAdmin: roleName === 'superuser' || roleName === 'org_admin',
    hasFullAccess: roleName === 'superuser' || roleName === 'org_admin',
    hasLimitedAccess: roleName === 'client_manager' || roleName === 'field_agent' || roleName === 'client',

    // Generic role check
    hasRole: (role: string | string[]) => {
      if (!roleName) return false;
      if (Array.isArray(role)) {
        return role.includes(roleName);
      }
      return roleName === role;
    },
  };
};
